let visibleMsgIds: string[] = [];

export const getVisibleMsgIds = () => visibleMsgIds;

export const addVisibleMsgId = (msgId: string) => {
  visibleMsgIds.push(msgId);
  visibleMsgIds = Array.from(new Set(visibleMsgIds));
};

export const removeVisibleMsgId = (msgId: string) => {
  const index = visibleMsgIds.findIndex((v) => v === msgId);
  if (index >= 0) {
    visibleMsgIds.splice(index, 1);
  }
};

export const clearVisibleMsgIds = () => {
  visibleMsgIds = [];
};
